import {OVERLAY_IDS} from '../selectors'

export const OVERLAY_SHOW = 'OVERLAY_SHOW'
export const OVERLAY_HIDE = 'OVERLAY_HIDE'
export const OVERLAY_STACK_REPLACE = 'OVERLAY_STACK_REPLACE'
export const OVERLAY_REPLACE_TOP = 'OVERLAY_REPLACE_TOP'

export const showOverlay = (
  id: string,
  extraState: Record<string, unknown> | null | undefined,
  ignoreHistory: boolean
) => ({
  type: OVERLAY_SHOW,
  params: {id, extraState},
  ignoreHistory
})

export const hideOverlay = (id: string, ignoreHistory: boolean) => ({
  type: OVERLAY_HIDE,
  params: {id},
  ignoreHistory
})

export const replaceOverlayStack = (overlays: string[]) => ({
  type: OVERLAY_STACK_REPLACE,
  params: {overlays}
})

export const replaceOverlayTop = (
  id: string,
  extraState: Record<string, unknown> | null | undefined,
  ignoreHistory: boolean
) => ({
  type: OVERLAY_REPLACE_TOP,
  params: {id, extraState},
  ignoreHistory
})

export type ModuleActionType =
  | ReturnType<typeof showOverlay>
  | ReturnType<typeof hideOverlay>
  | ReturnType<typeof replaceOverlayStack>
  | ReturnType<typeof replaceOverlayTop>

const changeOverlayVisibility = (id: string) => (
  willBecomeVisible: boolean,
  replaceOverlay?: boolean,
  ignoreHistory = false
) => (extraState: Record<string, unknown> = null) => {
  if (!willBecomeVisible) {
    return hideOverlay(id, ignoreHistory)
  }

  if (replaceOverlay) {
    return replaceOverlayTop(id, extraState, ignoreHistory)
  }

  return showOverlay(id, extraState, ignoreHistory)
}

export const changeRoomDetailsVisibility = changeOverlayVisibility(
  OVERLAY_IDS.roomDetails
)

export const changeDateSelectionVisibility = changeOverlayVisibility(
  OVERLAY_IDS.dateSelection
)

export const changeGuestSelectionVisibility = changeOverlayVisibility(
  OVERLAY_IDS.guestSelection
)

export const changeOfferDetailsVisibility = changeOverlayVisibility(
  OVERLAY_IDS.offerDetails
)

export const changePreferencesVisibility = changeOverlayVisibility(
  OVERLAY_IDS.preferences
)

export const changeMembershipVisibility = changeOverlayVisibility(
  OVERLAY_IDS.membership
)

export const changePaymentPreferenceVisibility = changeOverlayVisibility(
  OVERLAY_IDS.paymentPreference
)

export default showOverlay
